import type { LocalGiftcardKpiDto } from "common/models/api/models/LocalGiftcardKpiDto";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UseGetGiftCardsKpisParams {
    type?: string;
}

export default function useGetGiftCardsKpis(
    { type }: UseGetGiftCardsKpisParams = {},
    options?: UseQueryOptions<LocalGiftcardKpiDto, unknown, LocalGiftcardKpiDto, (string | undefined)[]>,
): UseQueryResult<LocalGiftcardKpiDto> {
    return useQuery(
        [Queries.GIFTCARDS_KPIS, type],
        async () => {
            const res = await giftcardsApi.getLocalGiftcardKpi({ type });
            return res.data;
        },
        { ...options },
    );
}
